import { Box, Stack, Typography } from '@mui/material';
import section2_icon1 from 'assets/img/ECommerce/section2_icon1.png';
import section2_icon2 from 'assets/img/ECommerce/section2_icon2.png';
import section2_icon3 from 'assets/img/ECommerce/section2_icon3.png';
import AnimatedButton from 'components/common/AnimatedButton';
import React, { JSX } from 'react';
import theme from 'theme/index';
import { E_COMMERCE_STYLES } from './config';
import { paths } from 'routes/routes/paths';
import { Link } from 'react-router-dom';

type Feature = { title: string; body: string; icon?: string };

export default function Section2(): JSX.Element {
  const items: Feature[] = [
    {
      title: 'Synchronous Enterprise Systems',
      body: 'Backend workflows that talk to each other — CRM, ERP, orders, inventory — all in sync.',
      icon: section2_icon1,
    },
    {
      title: 'Streamlined Operations',
      body: 'Reduce manual work, avoid data silos, and automate where it matters.',
      icon: section2_icon2,
    },
    {
      title: 'Customer Psychology That Converts',
      body: 'UI/UX built on how customers actually think — leading to more clicks and checkouts.',
      icon: section2_icon3,
    },
  ];

  return (
    <Box
      sx={{ px: 2, py: 6, pt: 1 }}
      maxWidth={E_COMMERCE_STYLES.container.maxWidth}
      mx={E_COMMERCE_STYLES.container.mx}
    >
      <Stack spacing={1}>
        <Typography variant="h3" className="font-helvetica-bold">
          Enterprises Need <br />{' '}
          <span style={{ color: theme.palette.darkBlue.main }}>Deep Clarity</span> Before Building A
          System
        </Typography>
        <Typography
          variant="h6"
          fontSize={13}
          width={'90%'}
          color="text.black"
          className="font-helvetica-light"
        >
          While most people see just a sleek online store, true e-commerce success runs much deeper.
          <br /> Underneath lies &nbsp;<b>a synchronous enterprise systems</b>&nbsp; that{' '}
          <b>streamlines operations </b> — and a <b> strategic use of customer psychology </b> that{' '}
          <b> drives conversions. </b>
        </Typography>
      </Stack>

      <Stack spacing={2} mt={3}>
        {items?.map((item, key) => (
          <Box
            key={key}
            sx={{
              bgcolor: '#E7EEFF',
              p: 3,
              borderRadius: 2,
              gap: 2,
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <Box
              component="img"
              src={item?.icon}
              alt="hero"
              sx={{
                width: '42px',
                height: '42px',
                borderRadius: 2,
              }}
            />

            <Typography className="font-helvetica-bold" variant="h5">
              {item.title}
            </Typography>
            <Typography
              variant="body2"
              fontWeight={100}
              className="font-helvetica-light"
              color="#000"
            >
              {item.body}
            </Typography>
          </Box>
        ))}
      </Stack>
      <Stack px={1} mt={3}>
        <Typography
          mb={3}
          variant="h6"
          fontSize={13}
          color="text.black"
          className="font-helvetica-light"
        >
          At Osperb,{' '}
          <b>
            {' '}
            we don’t just build what users see.
            <br />
          </b>{' '}
          We engineer what makes it work — and what makes it sell.
        </Typography>
        <Link to={paths.public.schedule}>
          <AnimatedButton label="Let’s Meet Online Today" sx={{ mt: 0 }} />
        </Link>
        <Typography maxWidth={300} mt={1} variant="body2" color="#676767" className="font-serif">
          No pitch. Just a{' '}
          <b>
            <u> 60-minute deep dive</u>{' '}
          </b>{' '}
          into what’s holding you back — and how to fix it.
        </Typography>
      </Stack>
    </Box>
  );
}
